import './App.css';
import '@mantine/core/styles.css';
import 'swiper/css';
import 'swiper/css/navigation';
import "primereact/resources/themes/saga-blue/theme.css"; // This imports theme.css from primereact themes module
import "primereact/resources/primereact.min.css"; // This imports primereact main css
// import Home from './Pages/Home';
import { Route, Routes } from 'react-router-dom';
// import Miscforms from './Pages/Miscforms';
// import Courtcal from './Pages/Courtcal';
import About from './Pages/About';
import AdminNavbar from './Components/Admin/Adminnavbar';
import AlertHistory from './Pages/Alerthistory';
// import Login from './Components/Auth/Login';
import { useEffect, useState } from 'react';
import { LoadingOverlay } from '@mantine/core';
import { Userauthcontexthooks } from './Hooks/Userauthcontexthooks';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./Components/Auth/Config/Firebasecredentials";
import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';
import Privacypolicy from './Privacypolicy/Privacypolicy';
import Websplash from './Components/Websplash/Websplash'; 
import PremiumLogin from './Components/Auth/Newlogin';
import PremiumHomePage from './Pages/Newhome';
import Profile from './Pages/Profile';
import Viewallprofessionals from './Pages/Viewallprofessionals';
import Viewalllegalupdates from './Pages/Viewalllegalupdates';
import Feedoption from './Components/Feedback/Feedoption';

function App() {
  const { user } = Userauthcontexthooks();
  const [IsServerWake, SetIsServerWake] = useState(false);
  const [visibile, setvisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => { // This Use effect for Server waking only
    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.hide(); // Hide the status bar on mobile platforms
      // StatusBar.setOverlaysWebView({ overlay: false }); // Push content below the status bar
    }

    let progressValue = 0;
    let intervalforProgress;

    const WakingServerProgress = () => {
      intervalforProgress = setInterval(() => {
        if (!IsServerWake) {
          progressValue += 1;
          setProgress(progressValue);

          // Pause at specific points and resume after 10 seconds
          if ([25, 50, 75].includes(progressValue)) {
            clearInterval(intervalforProgress);
            setTimeout(() => {
              WakingServerProgress();
            }, 10 * 1000);
          }

          // Stop at 95%
          if (progressValue === 95) {
            clearInterval(intervalforProgress);
          }
        }
      }, 200);
    };
    const waitForServer = async () => {
      try {
        const res = await fetch("https://cdr-backend.onrender.com/", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (res.status === 201) {
          clearInterval(intervalforProgress);
          setProgress(100);
          SetIsServerWake(true);
          setvisible(false);
        }
      } catch (error) {
        console.error("Failed to wake server:", error);
      }
    };
    // Start progress
    WakingServerProgress();
    waitForServer();

    return () => {
      clearInterval(intervalforProgress);
    };
  }, [IsServerWake])

  useEffect(() => { // This Use effect for App notification only.
    if (Capacitor.getPlatform() === 'web') {
      console.log("🔥 Skipping Push Firebase messaging setup on web.");
      return;
    } else {
      PushNotifications.requestPermissions().then(result => {
        if (result.receive === 'granted') {
          PushNotifications.register();
        }
      });

      PushNotifications.addListener('registration', async (token) => {
        console.log('📱 Device FCM token:', token.value);
        // ✅ Send token.value to your backend (save to DB for notification sending)
        // 👇 Send the token to your backend
        try {
          const res = await fetch('https://cdr-backend.onrender.com/save/app-fcm-token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user}`,  // Replace `user` with your auth token or user ID
            },
            body: JSON.stringify({
              fcmtoken: token.value,
            }),
          });
          if (res.status === 200) {
            console.log("[✅] App FCM token sent to backend successfully.");
            localStorage.setItem('fcmtoken', token.value);
          } else {
            console.warn("[⚠️] App Failed to send FCM token:");
          }
        } catch (err) {
          console.error("[❌] Error sending FCM token:", err);
        }
      });

      PushNotifications.addListener('pushNotificationReceived', (notification) => {
        console.log('📨 Notification received:', notification);
        // OPTIONAL: Show a native toast or alert
        alert(`🔔 ${notification.title}\n${notification.body}`);
        // Show system-level local notification manually
        LocalNotifications.schedule({
          notifications: [
            {
              id: Date.now(),
              title: notification.title || 'Upcoming Court Date Reminder',
              body: notification.body || 'You have a reminder',
              schedule: { at: new Date(Date.now() + 1000) },
            }
          ]
        });
      });

      PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        console.log('🔗 User interacted with notification:', notification);
      });
    }
  }, [user]);

  useEffect(() => { // This useeffect run only for web push notification.
    // ✅ Check both web platform and actual feature support
    const isWeb = Capacitor.getPlatform() === 'web';
    const supportsServiceWorker = 'serviceWorker' in navigator;
    const supportsNotification = 'Notification' in window;

    if (!isWeb || !supportsServiceWorker || !supportsNotification) {
      console.log("🔥 Skipping Web Push Notification setup: Unsupported environment");
      return;
    }

    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        getToken(messaging, {
          vapidKey: "BGlGDbX0QCcAHwG1YmIRvExy4GTgfuahxmYEm-_S9JqLmhLg1d8VxjDvaLUAGkLsiSEdtnkvKPRgYOFRH1QxOuU",
          serviceWorkerRegistration: registration
        }).then((token) => {
          console.log("Web FCM Token:", token);
        }).catch((err) => {
          console.error("Error getting Web FCM token", err);
        });
      });

    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log("✅ Notification permission granted.");
      }
    });

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📢 Foreground notification received:");
      const { title, body } = payload.notification;

      if (Notification.permission === 'granted') {
        new Notification(title || "📣 New Notification", {
          body: body || "You have a new alert.",
          icon: "/logo192.png",
          badge: '/Alert.png',
        });
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => { // This use effect for Generate FCM Token and saved in our DB.
    if (Capacitor.getPlatform() !== 'web') {
      console.log("🔥 Skipping Push Firebase messaging setup on app.");
      return;
    }
    const getAndSendToken = async () => {
      try {
        const currentToken = await getToken(messaging, {
          vapidKey: 'BGlGDbX0QCcAHwG1YmIRvExy4GTgfuahxmYEm-_S9JqLmhLg1d8VxjDvaLUAGkLsiSEdtnkvKPRgYOFRH1QxOuU',
        });

        if (currentToken) {
          //const savedToken = localStorage.getItem('fcmtoken');

          // ✅ Always send token to backend (force update)
          const res = await fetch('https://cdr-backend.onrender.com/save/web-fcm-token', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${user}`
            },
            body: JSON.stringify({ fcmtoken: currentToken }),
          });

          if (res.status === 200) {
            localStorage.setItem('fcmtoken', currentToken);
          }
        }
      } catch (err) {
        console.error("Error retrieving or saving Web FCM token:", err);
      }
    };

    if (user) {
      getAndSendToken();
    }
  }, [user]);
  return (
    <>
      <LoadingOverlay visible={visibile} loaderProps={{
        children: <>
          <Websplash progress={progress} />
        </>
      }} overlayOpacity={1}
        overlayColor="#fff" />


      <Routes>

        <Route path="/" element={user ? <PremiumHomePage IsServerWake={IsServerWake} /> : <PremiumLogin IsServerWake={IsServerWake} />} />
        {/* <Route path='/' element={<PremiumLogin />} /> */}
        {/* <Route path='/v2/home' element={<PremiumHomePage />} /> */}
        <Route path='/v2/profile' element={<Profile />} />
        <Route path='/v2/view-all-legal-professionals' element={<Viewallprofessionals />} />
        <Route path="/v2/view-all-legal-updates" element={<Viewalllegalupdates />} />
        <Route path='/v2/feedback-support' element={<Feedoption/>} />

        {/* <Route path='/view/misc-forms' element={<Miscforms />} /> */}
        {/* <Route path='/view/court-calender' element={<Courtcal />} /> */}
        <Route path='/cdr/about' element={<About />} />
        {/* <Route path='cdr/contact' element={<Contactus />} /> */}
        <Route path='/cdr/alert-history' element={<AlertHistory />} />
        {/* <Route path="/cdr/web-splash" element={<Websplash />} /> */}

        {/* Admin Routes */}
        <Route path="/cdr/admin" element={<AdminNavbar IsServerWake={IsServerWake} />} />

        <Route path="cdr/our/privacy-policy" element={<Privacypolicy />} />
      </Routes>
    </>
  );
}

export default App;
